import Product from '@vue-storefront/core/modules/catalog/types/Product'
import Vue from 'vue';

export const AddToCart = {
  name: 'AddToCart',
  data () {
    return {
      isAddingToCart: false
    }
  },
  props: {
    product: {
      required: true,
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    },
    categoryId: {
      type: Number
    }
  },
  methods: {
    async addToCart (product: Product) {
      this.isAddingToCart = true
      // collect all categories with age restriction
      let ageRestrictСategories = []
      if (product && (!product.hasOwnProperty('category') || !product.hasOwnProperty('category_ids'))) {
        product.category = []
        product.category.push(this.$store.getters['partners/getCurrentPartner'].root_category_id)
      }
      // get categories from Categories page
      let categoriesForRestriction = this.$store.getters['products_categories/categories']
      if (categoriesForRestriction.length == 0) {
        // get categories from Product page. Must be added "category_age_restriction" field in local.json
        //   "entities": {
        //     "category": {
        //       "includeFields": [
        //             "category_age_restriction"
        categoriesForRestriction = this.$store.getters['category/getCategories']
      }

      if (categoriesForRestriction && categoriesForRestriction.length) {
        categoriesForRestriction.map(item => {
          if (item.hasOwnProperty('category_age_restriction') && item.category_age_restriction) {
            ageRestrictСategories.push(item.entity_id)
          }
          let childData = item.children_data
          if (childData) {
            let recurGetIds = (childData) => {
              childData.map(child => {

                if (child.hasOwnProperty('category_age_restriction') && child.category_age_restriction) {
                  ageRestrictСategories.push(child.entity_id)
                }
                if (child.children_data) {
                  recurGetIds(child.children_data)
                }
              })
            }
            recurGetIds(childData)
          }
        })
      }

      if (product.category_ids !== undefined) {
        const passedAge = ageRestrictСategories.some(r => product.category_ids.indexOf(r) >= 0);
        let ageConfirmation = Vue.$cookies.get('userAgePassed');
        if (passedAge) {
          if (ageConfirmation === null || ageConfirmation === undefined) {
              this.$nextTick(() => {
                this.$bus.$emit('modal-show', 'modal-age-confirm');
                this.$store.dispatch('user/addedAgeConfirmationProduct', product)
              });
              this.isAddingToCart = false;
              return;
          } else if (ageConfirmation === 'false') {
              this.notifyUser({
                type: 'error',
                message: this.$t('To buy this product your age should be 18 or higher!'),
                action1: { label: this.$t('OK') },
                action2: null
              })
              this.isAddingToCart = false;
              return;
          }
        }
      }
      try {
        const diffLog = await this.$store.dispatch('cart/addItem', { productToAdd: product })
        if (diffLog) {
          if (diffLog.clientNotifications && diffLog.clientNotifications.length > 0) {
            diffLog.clientNotifications.forEach(notificationData => {
              this.notifyUser(notificationData)
            })
          }
        } else {
          this.notifyUser({
            type: 'success',
            message: this.$t('Product has been added to the cart!'),
            action1: { label: this.$t('OK') },
            action2: null
          })
        }
          return diffLog
      } catch (err) {
        this.notifyUser({
          type: 'error',
          message: err,
          action1: { label: this.$t('OK') }
        })
        return null
      } finally {
        this.isAddingToCart = false
      }
    }
  }
}
